/* RESPONSIBLE TEAM: team-omni */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class DiscordIntegrationSerializer extends EmbercomBaseSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    if (payload && !Array.isArray(payload) && !payload['discord/integrations']) {
      payload = { 'discord/integrations': [payload] };
    } else if (!payload) {
      payload = { 'discord/integrations': [] };
    }
    return super.normalizeArrayResponse(store, primaryModelClass, payload, id, requestType);
  }
}
